module.exports = __webpack_public_path__ + "img/profile_password_reset.7be258ff.png";